import { cloneElement, isValidElement, useId } from "react";
import Icon from "../icons/Icon";

// Label + control + hint/error. If the single child is an element it receives
// id, aria-describedby and aria-invalid automatically, so callers only write
// <Field label="Email" error={err}><Input .../></Field>.
export default function Field({ label, hint, error, htmlFor, className = "", children }) {
  const autoId = useId();
  const id = htmlFor || autoId;
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined;
  const control = isValidElement(children)
    ? cloneElement(children, {
        id: children.props.id || id,
        "aria-describedby": describedBy,
        "aria-invalid": error ? "true" : undefined,
        invalid: error ? true : children.props.invalid,
      })
    : children;

  return (
    <div className={`rl-field ${className}`.trim()}>
      {label && <label className="rl-label" htmlFor={isValidElement(children) ? children.props.id || id : id}>{label}</label>}
      {control}
      {error ? (
        <div className="rl-field-error" id={`${id}-error`} role="alert">
          <Icon name="alert-circle" size={14} />
          {error}
        </div>
      ) : hint ? (
        <div className="rl-field-hint" id={`${id}-hint`}>{hint}</div>
      ) : null}
    </div>
  );
}
